import Vue from 'vue'
import router from '@/router'
import * as modules from '../../store/decorator'

Vue.router = router;

Vue.use(require('@websanova/vue-auth'), {
    auth: require('../drivers/auth-basic'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    loginData: {
        url: process.env.VUE_APP_DOT_NET_API_LOGIN, 
        method: 'POST', 
        fetchUser: false
    },
    logoutData: {
        redirect: '/login'
    },
    fetchData: {
        url: process.env.VUE_APP_DOT_NET_API_USER,
        method: 'GET',
        enabled: false
    },
    refreshData: {
        url: `${ process.env.VUE_APP_DOT_NET_API_BASE_URL }${ process.env.VUE_APP_DOT_NET_API_REFRESH }`, 
        method: 'PUT',
        enabled: true,
        interval: 30
    },
    authRedirect: {
        path: '/login'
    },
    forbiddenRedirect: {
        path: '/agreement'
    },
    notFoundRedirect: {
        path: '/login'
    }
})